// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"c78fb4a384fa281f","1":"c421916b1231146d","src_app_shared_shared_module_ts":"ee2c2fd84d970b3a"}[chunkId] + ".js";
};